import { Download, X } from "lucide-react";
interface FilePreviewProps {
  fileDetails: { type: string; url: string };
  onClose: () => void;
}

export default function FilePreview({
  fileDetails,
  onClose,
}: FilePreviewProps) {

  const handleDownload = () => {
    if (fileDetails.type === "image") {
      // Create an anchor element
      const a = document.createElement('a');
      a.href = fileDetails.url;
      
      // Extract filename from URL or use a default name
      const filename = fileDetails.url.split('/').pop() || 'downloaded-image';
      a.download = filename;
      
      // Append to body, click and remove
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center p-2 overflow-hidden">
      <div className="relative flex flex-col items-center justify-start rounded-md hiddenScrollbar bg-white w-[750px] h-[650px] overflow-hidden overflow-y-auto">
        <h2 className="w-full sticky top-0 p-2 flex items-center justify-between border-b border-b-gray-400/40">
          <span className="font-semibold text-sm">
            Patient Prescriptions / Active Medications
          </span>
          <button onClick={onClose}>
            <X />
          </button>
        </h2>
        {fileDetails.type === "image" && (
          <img
            src={fileDetails.url}
            alt={fileDetails.url}
            className="w-[90%] h-[90%] object-contain"
          />
        )}
        <button onClick={handleDownload} className=" absolute bottom-2 right-2"><Download className=" w-6 h-6"/></button>
      </div>
    </div>
  );
}
